import { freeze } from 'utils/dom'

export const GLYPH = {
  dot: <>&#183;</>
}

export const ICON = freeze({
  add: 'fas fa-plus',
  back: 'fa fa-arrow-left',
  bookclub: 'fas fa-comments', // more than just chat?
  chat: 'fas fa-message',
  check: 'fas fa-check',
  checkBox: 'far fa-square',
  checkBoxExed: 'fas fa-square-xmark', // to show a negative in filters
  checkBoxFilled: 'fas fa-square-check',
  close: 'fas fa-times',
  code: 'fas fa-code',
  copy: 'far fa-copy',
  community: 'fas fa-user-friends',
  dashboards: 'fas fa-chart-area',
  dev: 'fas fa-bahai',
  download: 'fas fa-download',
  edit: 'fa fa-pen',
  // explore: 'fas fa-drafting-compass',
  explore: 'fas fa-book-open-reader',
  extract: 'fas fa-right-from-bracket',
  failed: 'fas fa-times', // intentional duplicate of `close`
  fanfic: 'fas fa-burst fa-rotate-180',
  grabSide: 'fas fa-grip-lines-vertical',
  grabUpDown: 'fas fa-grip-lines',
  help: 'fa fa-question-circle',
  hide: 'fas fa-ban',
  home: 'fa fa-dharmachakra',
  info: 'fa fa-circle-info',
  insert: 'fas fa-right-to-bracket',
  key: 'fas fa-key',

  like: 'fas fa-thumbs-up',
  likeOff: 'far fa-thumbs-up',

  link: 'fas fa-arrow-up-right-from-square fa-xs',
  loading: 'loading-inline',

  lock: 'fa fa-lock',
  lockOff: 'fa fa-lock-open',

  menuBars: 'fas fa-bars',
  menuPull: 'fas fa-angle-down fa-xs',
  noView: 'fas fa-eye-slash',
  notify: 'fas fa-bell',
  notifyOff: 'far fa-bell-slash',
  opEq: 'fas fa-equals',
  opGt: 'fas fa-greater-than',
  opLt: 'fas fa-less-than',
  opNeq: 'fas fa-not-equal',
  ops: 'fas fa-user-gear',
  orderA2Z: 'fas fa-arrow-down-a-z', // ascending
  orderZ2A: 'fas fa-arrow-down-z-a', // descending
  play: 'fa fa-play',
  pool: 'fa fa-wrench',
  radio: 'far fa-circle',
  radioFilled: 'far fa-circle-dot',
  redo: 'fa fa-rotate',
  remove: 'fas fa-minus',
  reply: 'far fa-comments',
  report: 'fas fa-flag',
  reportOff: 'far fa-flag',
  review: 'far fa-comment-alt',
  search: 'fa fa-magnifying-glass',
  send: 'fa fa-paper-plane',
  server: 'fa fa-server',
  services: 'fa fa-dharmachakra',
  share: 'fa fa-share-nodes',
  shrink: 'fas fa-down-left-and-up-right-to-center fa-rotate-45',
  signon: 'fas fa-sign-in-alt',
  stretch: 'fas fa-arrows-left-right-to-line',
  sys: 'fas fa-screwdriver-wrench',
  trash: 'fa fa-trash',
  up: 'fa fa-angles-up',
  view: 'fas fa-eye',
  website: 'fa fa-globe'
})

export const STATE_ICONS = freeze({
  power: freeze({
    on: 'green fas fa-circle-up',
    off: 'red fas fa-circle-down',
    unknown: 'gray fas fa-circle-question'
  }),
  bmc: freeze({
    nominal: 'green fas fa-circle-check',
    unknown: 'gray fas fa-circle-question',
    unstable: 'warn fas fa-circle-exclamation',
    failed: 'red fas fa-circle-xmark'
  }),
  condition: freeze({
    nominal: 'green fas fa-circle-check',
    unknown: 'gray fas fa-circle-question',
    warning: 'warn fas fa-circle-exclamation',
    failing: 'red fas fa-circle-xmark'
  })
})

export function MenuLabelIcon({ children }) {
  return (
    <>
      {children}
      <Icon type="menuPull" />
    </>
  )
}
export function AdminStr({ children }) {
  return (
    <>
      <Icon type="key" />
      {children}
    </>
  )
}

export function Icon({ type, className = '', onClick, style }) {
  const iconCss = ICON[type]
  if (!iconCss) throw new Error('Invalid icon type=' + type)
  return (
    <i className={className + ' ' + iconCss} onClick={onClick} style={style} />
  )
}

export function PivotIcon({ open, className = '', family = 'fas' }) {
  return (
    <i
      className={`${family} fa-${open ? 'minus' : 'plus'}-square ${className}`}
    />
  )
}

export function CheckIcon({ checked, className = '' }) {
  return (
    <i
      className={`${
        checked ? 'fas fa-square-check' : 'far fa-square'
      } ${className}`}
    />
  )
}

// export function CheckIcon({ checked, className = '' }) {
//   return (
//     <i className={`${checked ? 'fas fa-check' : 'far fa'}-square ${className}`} />
//   )
// }

export function RadioIcon({ checked, className = '' }) {
  return (
    <i
      className={`${
        checked ? 'far fa-circle-dot' : 'far fa-circle'
      } ${className}`}
    />
  )
}

export function AngleIcon({ open, className = '' }) {
  return <i className={`fas fa-angle-${open ? 'down' : 'right'} ${className}`} />
}
